import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

// Variable fonts — bundled so we never depend on a CDN for the chrome.
import '@fontsource-variable/geist/index.css';
import '@fontsource-variable/jetbrains-mono/index.css';

import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);